<template>
<div class="chapter">
<div class="inner_page">
<div id="Maps">
<p class="fig-img" id="map_1"><a id="page_11"><img alt="" class="image" src="images/ufig_4.jpg"/></a></p><a id="page_11">
<p class="fig-caption"><b>The British Sector on the Aisne, 27 May 1918.</b></p>
</a><p class="fig-img" id="map_2"><a id="page_11"></a><a id="page_12"><img alt="" class="image" src="images/ufig_5.jpg"/></a></p><a id="page_12">
<p class="fig-caption"><b>British Divisions, 27 May.</b></p>
</a></div><a id="page_12">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Maps.vue?58eee67e